export const products = [
  {
    id: 1,
    title: "Unisex Cologne",
    picture: "/products/cologne.jpg",
    quantity: 0,
    rating: 3.5,
    price: 35,
  },
  {
    id: 2,
    title: "Apple iWatch",
    picture: "/products/iwatch.jpg",
    quantity: 0,
    rating: 5,
    price: 199,
  },
  {
    id: 3,
    title: "Unique Mug",
    picture: "/products/mug.jpg",
    quantity: 0,
    rating: 4.5,
    price: 15,
  },
  {
    id: 4,
    title: "Men's wallet",
    picture: "/products/wallet.jpg",
    quantity: 0,
    rating: 4,
    price: 48,
  },
];
